// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/components/chatinterface/components/chatcomposer/index.scss
// module id = 2529
// module chunks = 13